import React, { useState, useCallback, useRef } from "react";
import Cropper from "react-easy-crop";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
// import Slider from "@material-ui/core/Slider";
// import Typography from "@material-ui/core/Typography";
import getCroppedImg from "./cropImage";

export const UplaodImgWithCropper = (props) => {
  const {
    cropImg,
    setcropImg,
    iscropImgEdited,
    setIscropImgEdited,
    setEdit,
    edit,
    setThumbnailImageFlag,
  } = props;
  const inputRef = useRef();

  const triggerFileSelectPopup = () => inputRef.current.click();

  // popups
  const [show, setShow] = useState(false);
  // img
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [prevImg, setPrevimg] = useState("");

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleSetCropperImg = (e) => {
    setShow(true);
    setPrevimg(URL.createObjectURL(e.target.files[0]));
  };

  const modelClose = () => {
    setShow(false);
    setIscropImgEdited(false);
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        prevImg,
        croppedAreaPixels,
        rotation
      );
      // console.log("done", croppedImage);
      setcropImg(croppedImage);
      setIscropImgEdited(true);
      setShow(false);
      setZoom(1);
      setRotation(0);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  return (
    <div className="upload_main" style={{ cursor: "pointer" }}>
      <Modal show={show} onHide={() => setShow(false)} style={{ marginTop: 0 }}>
        <Modal.Header></Modal.Header>
        <Modal.Body style={{ width: "100%", height: 350 }}>
          <div>
            <Cropper
              image={prevImg}
              crop={crop}
              rotation={rotation}
              zoom={zoom}
              aspect={1 / 1}
              cropShape="square"
              showGrid={false}
              onCropChange={setCrop}
              onRotationChange={setRotation}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="modelFooter">
          <div className="btn-footer">
            <div className="btns">
              <Button
                onClick={() => {
                  modelClose();
                  setThumbnailImageFlag(false);
                }}
                className="close_btn_cropper"
              >
                Close
              </Button>
            </div>
            <div className="btns">
              <Button
                onClick={() => {
                  showCroppedImage();
                  setThumbnailImageFlag(true);
                }}
                className="green-btn mt-3 btn btn-primary"
              >
                Save Changes
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
      {/* uplaod */}
      <div
        className="upload_main"
        onClick={edit == true ? triggerFileSelectPopup : ""}
        style={edit == true ? { cursor: "pointer" } : { cursor: "no-drop" }}
      >
        <input
          type="file"
          accept="image/*"
          ref={inputRef}
          style={{ display: "none" }}
          onChange={handleSetCropperImg}
          onClick={(e) => (e.target.value = null)}
        />
        <div>
          {cropImg == "" ? (
            <div
              className="upload_main"
              style={{
                border: "2px dashed rgb(169, 207, 75)",
                width: "100%",
                borderRadius: 15,
              }}
            >
              <div style={{ textAlign: "center" }} className="centerText">
                <p className="info_bannerImg">
                  Please upload a thumbnail image for the store banner. Upload
                  store image in dimension 1:1 ratio.
                </p>
                {/* <p className="textOR">
                  <span>OR</span>
                </p> */}
                <label htmlFor="logoImg" className="browse_btn">
                  Browse
                </label>
                <img
                  loading="lazy"
                  className="img-circle-edit"
                  style={{
                    backgroundColor: "rgb(243, 242, 242)",
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                    display: "none",
                  }}
                />
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onClick={(e) => (e.target.value = null)}
                />{" "}
              </div>
            </div>
          ) : (
            <img loading="lazy" src={cropImg} className="thumbnailImgStore" />
          )}
        </div>
      </div>
    </div>
  );
};
